import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import Image from 'swag-client-common/components/ui/image';
import classNames from 'classnames';
import { isDefaultBundleImage } from 'swag-common/utils/custom-store-product/product-is-bundle.util';
import classes from './image-popup.scss';
export const ImagePopup = ({
  open,
  params,
  onClose
}) => {
  return /*#__PURE__*/React.createElement(InfoDialog, {
    open: open,
    dataPopup: "GiveawayBigImage",
    subHeader: params.name,
    titleClass: classes.title,
    content: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
      src: params.image,
      alt: params.name,
      className: classNames(classes.image, {
        [classes.bundleWithoutPackagingImage]: isDefaultBundleImage(params.image)
      })
    })),
    onRequestClose: onClose,
    showCloseButton: true
  });
};